
/* eslint-disable @next/next/no-img-element */
// libraries
import { isColorLight, marca_dagua } from '../../../utils/FunctionsGlobals';
import { openExternalSimulator, resolveExternalSimulatorUrl } from '../../../utils/externalSimulator';
import { anuncieWhatsAppDoSite } from '../../../utils/anuncieWhatsApp';
import { QUERO_MAIS_INFORMACOES_ROTA, temQueroMaisInformacoes } from '../../../utils/queroMaisInformacoes';
import { ANUNCIE_PAGINA_ROTA, anuncieVaiParaPaginaDoSite } from '../../../utils/anunciePaginaDoSite';
import { appendCodsiteQuery } from '../../../utils/url';
import Router from 'next/router';
import styles from './OwnersPieces.module.css';
import { COR_MARFIM, fontesMaioresDoSite } from '../../../utils/fontesMaioresPorSite';

// cs2653 (17/09): com corconfig=5 e cor1 = cor5 = #ffffff, subtítulos, parágrafos e botão saíam brancos
// no fundo branco. Pedido do cliente: TODA a fonte da seção "Quem somos" em preto — só nesta licença.
// Padrão de lista de codsites do repo; zero diff para os demais tenants.
const OWNERS_SECAO_TODA_PRETA = new Set([2653]);
// cs2485 (25/09): imagem alinhada com a 1ª linha do parágrafo, desconsiderando o título (o padrão centraliza
// verticalmente e a foto, mais alta que o texto, começava acima do título). Só desktop; zero diff para os demais.
const OWNERS_IMAGEM_NO_TOPO = new Set([2485]);
// cs2641 (01/10): imagem das sócias como FUNDO da seção (arte já composta: marrom à esquerda, sócias à direita).
// O texto fica na coluna da esquerda, em branco; o título segue na cor do site. `base` = marrom da borda da
// arte (preenche o que ela não cobre e vale enquanto a imagem carrega). Só nesta licença; zero diff para os demais.
const OWNERS_FOTO_DE_FUNDO: Record<number, { url: string; base: string }> = {
    2641: { url: 'https://fotos2.fra1.cdn.digitaloceanspaces.com/banners/2641/1790861171-1790861174286.png', base: '#39160d' },
};
// cs2641 (01/10): pedido do Daniel — a seção "Quem somos" fica, mas SEM os dois botões de ação
// ("Anuncie Seu Imóvel" e "Simular Financiamento"). Só nesta licença; zero diff para os demais.
const OWNERS_SEM_BOTOES = new Set([2641]);

const OwnersPieces: React.FC<{
    allOwners: any;
    site?: any;
    setFullScram?: (_value: number) => void;
    origin?: string;
    path?: string;
}> = ({ allOwners, site, setFullScram, origin = '', path = '' }) => {

    // renders
    const RenderDescription = (v: any) => {
        if(v != ""){
            return (
                <p key={v} className={styles.description} style={site?.id == 2126 ? {fontSize: 23} : {}}>
                    {v}
                </p>
            );
        }
    };

    const externalSimulatorUrl = resolveExternalSimulatorUrl(site);

    const handleSimulatorClick = () => {
        if (externalSimulatorUrl) {
            openExternalSimulator(externalSimulatorUrl);
            return;
        }
        if (setFullScram) {
            setFullScram(1);
        }
    };

    // cs2669 (utils/queroMaisInformacoes): o botão leva ao formulário; o WhatsApp abre de lá, com nome e telefone.
    const queroMaisInformacoes = temQueroMaisInformacoes(site);

    const handleAnnounceClick = async (e: React.MouseEvent) => {
        e.preventDefault();

        if (queroMaisInformacoes) {
            Router.push(appendCodsiteQuery(QUERO_MAIS_INFORMACOES_ROTA, site?.id, window.location.host));
            return;
        }

        // cs2636 (utils/anunciePaginaDoSite): o botão leva à página do formulário "Anuncie seu imóvel" do site.
        if (anuncieVaiParaPaginaDoSite(site)) {
            Router.push(appendCodsiteQuery(ANUNCIE_PAGINA_ROTA, site?.id, window.location.host));
            return;
        }

        const whatsappText = "Olá, gostaria de anunciar meu imóvel";
        const phone = anuncieWhatsAppDoSite(site) ?? `55${(site?.Dados?.tel1 || site?.Dados?.tel2)?.replace(/\D/g, "")}`;
        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(whatsappText)} Link: ${origin}${path}`;

        setTimeout(() => {
            window.open(whatsappUrl, "_blank");
        }, 300);
    };

    const fontesMaiores = fontesMaioresDoSite(site);
    var cor_fundo = fontesMaiores ? COR_MARFIM : allOwners?.corconfig == 1 ? site?.cor1 : allOwners?.corconfig == 2 ? site?.cor2 : allOwners?.corconfig == 3 ? "#000000" : allOwners?.corconfig == 4 ? site?.cor1 : allOwners?.corconfig == 5 ? site?.cor5 : allOwners?.corconfig == 6 ? site?.cor3 : "#ffffff"
    const secaoPreta = OWNERS_SECAO_TODA_PRETA.has(Number(site?.id));
    var cor_letra = secaoPreta || site?.id == "2352"
        ? "#000000"
        : allOwners?.corconfig == 1
            ? site?.cor2
            : allOwners?.corconfig == 2
                ? site?.cor1
                : allOwners?.corconfig == 3
                    ? "#ffffff"
                    : allOwners?.corconfig == 4
                        ? site?.cor5
                        : allOwners?.corconfig == 5
                            ? site?.cor1
                            : allOwners?.corconfig == 6 ? site?.cor3 == "#ffffff" || site?.cor3 == "#FFFFFF"
                                ? "#000000"
                                : "#ffffff" : "#000000";
    const cor_font = secaoPreta ? "#000000" : isColorLight(cor_fundo) ? site?.cor11 : site?.cor13;
    const fotoDeFundo = OWNERS_FOTO_DE_FUNDO[Number(site?.id)];
    if (fotoDeFundo) {
        cor_fundo = fotoDeFundo.base;
        cor_letra = "#ffffff";
    }
    const containerClasses = [styles.container, fontesMaiores && styles.fontesMaiores, fotoDeFundo && styles.fotoDeFundo].filter(Boolean).join(' ');

    return (
        <div>
            <div
                className={containerClasses}
                style={fotoDeFundo
                    ? ({ color: cor_letra, backgroundColor: cor_fundo, '--owners-foto': `url("${fotoDeFundo.url}")` } as React.CSSProperties)
                    : { color: cor_letra, backgroundColor: cor_fundo}}
            >
                <div className={OWNERS_IMAGEM_NO_TOPO.has(Number(site?.id)) ? `${styles.content_wrapper} ${styles.imagemNoTopo}` : styles.content_wrapper}>
                    <div className={styles.text_content}>
                        <div className={styles.label} style={{color: cor_font}}><b>{allOwners?.card_titulo.toUpperCase()}</b></div>
                        {allOwners?.subtitulo_1 != "" &&
                            <p className={styles.subtitle}>
                                {allOwners?.subtitulo_1}
                            </p>
                        }
                        {RenderDescription(allOwners?.paragrafo_1)}
                        {allOwners?.subtitulo_2 != "" &&
                            <p className={styles.subtitle}>
                                {allOwners?.subtitulo_2}
                            </p>
                        }
                        {RenderDescription(allOwners?.paragrafo_2)}
                        {allOwners?.subtitulo_3 != "" &&
                            <p className={styles.subtitle}>
                                {allOwners?.subtitulo_3}
                            </p>
                        }
                        {RenderDescription(allOwners?.paragrafo_3)}

                        {/* Botões de Ação */}
                        {!OWNERS_SEM_BOTOES.has(Number(site?.id)) && (
                        <div className={styles.buttons_container}>
                            <button
                                className={styles.button_primary}
                                onClick={handleAnnounceClick}
                                style={{ backgroundColor: cor_letra, color: cor_fundo }}
                            >
                                {queroMaisInformacoes ? 'Quero mais informações' : 'Anuncie Seu Imóvel'}
                            </button>

                            {site?.simulador && (
                                <button
                                    className={styles.button_secondary}
                                    onClick={handleSimulatorClick}
                                    style={{ borderColor: cor_letra, color: cor_letra }}
                                >
                                    Simular Financiamento
                                </button>
                            )}
                        </div>
                        )}

                       {/* Estatísticas */}
                        {site?.id !== 2305 || site?.id != 2245 &&
                        site?.vgv_total !== "" &&
                        site?.total_cidades > 0 &&
                        site?.total_imoveis > 0 && (
                        <div className={styles.stats_container}>
                            <div className={styles.stat_item}>
                            <span className={styles.stat_label}>VGV</span>
                            <span className={styles.stat_value}>
                                {site?.vgv_total ? site.vgv_total : '347 milhões'}
                            </span>
                            </div>
                            <div className={styles.stat_item}>
                            <span className={styles.stat_label}>Imóveis</span>
                            <span className={styles.stat_value}>
                                {site?.total_imoveis || '348'}
                            </span>
                            </div>
                            <div className={styles.stat_item}>
                            <span className={styles.stat_label}>Cidades</span>
                            <span className={styles.stat_value}>
                                {site?.total_cidades || '7'}
                            </span>
                            </div>
                        </div>
                        )}
                    </div>

                    {allOwners?.linkbanner && (
                        <div className={styles.image_content}>
                            <img
                                src={site?.marca_dagua?.ativada && allOwners?.linkbanner?.includes("//fotos.sobressai") ? marca_dagua(allOwners?.linkbanner, site,"g",true) : allOwners?.linkbanner}
                                alt="Descrição"
                                className={styles.owners_image}
                                height={1000}
                                width={1000}
                                loading="lazy"
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default OwnersPieces;
